var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import { jsx, jsxs } from "react/jsx-runtime";
import { Flex, Grid, Radio, Space, Typography, Select } from "antd";
import { CloseOutlined } from "@ant-design/icons";
import { useCallback, useEffect, useMemo, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import {
  ArrowDown,
  LeagueApi,
  LeagueHeader,
  Loader,
  withScrollToTop,
  useTranslation
} from "@inscore/shared";
import StatsApi from "./../../api/StatsApi.js";
import { ReactComponent as Calendar } from "./../../assets/icons/calendar.svg";
import SearchLeagues from "./searchLeagues/SearchLeagues";
import {
  mapStatsData,
  mapSubjectsToOptions,
  toSortDir,
  translateOr
} from "./statsService";
import "./stats.css";
import StatsTable from "./statsTable/StatsTable";
import StatsFilter, {
  StatsRangeFilter
} from "./statsTable/statsFilter/StatsFilter";
const { Title } = Typography;
const { useBreakpoint } = Grid;
const Stats = ({ token, renderNewVersion = true }) => {
  var _a, _b;
  const { t } = useTranslation();
  const screens = useBreakpoint();
  const isMobile = !screens.md;
  const [searchedLeague, setSearchedLeague] = useState(null);
  const [chosenLeague, setChosenLeague] = useState(null);
  const [leagueDetails, setLeagueDetails] = useState(null);
  const [currentSeason, setCurrentSeason] = useState(null);
  const [subjects, setSubjects] = useState([]);
  const [subject, setSubject] = useState(null);
  const [loadingLeagueDetails, setLoadingLeagueDetails] = useState(true);
  const [statsData, setStatsData] = useState(null);
  const [filters, setFilters] = useState({});
  const [sort, setSort] = useState({});
  const [searchParams, setSearchParams] = useSearchParams();
  const [loadingTableData, setLoadingTableData] = useState(true);
  const navigate = useNavigate();
  const getLeagueDetailsApi = LeagueApi.getLeagueDetails();
  const getSpecialStatsApi = StatsApi.getSpecialStats();
  const getSpecialStatsMetaDataApi = StatsApi.getSpecialStatsMetaData();
  const { tableData, filterOptions } = useMemo(
    () => statsData ? mapStatsData(statsData, token, t, sort) : { tableData: null, filterOptions: [] },
    [statsData, token, t, sort]
  );
  const id = +searchParams.get("l");
  const seasonId = +searchParams.get("s");
  useEffect(() => {
    setCurrentSeason(null);
    id && getLeagueDetails(
      {
        id,
        seasonId: seasonId || null
      },
      (currentSeason2) => setCurrentSeason(currentSeason2)
    );
    return () => {
      getLeagueDetailsApi.cancel();
    };
  }, [id, seasonId]);
  useEffect(() => {
    var _a2;
    (currentSeason == null ? void 0 : currentSeason.id) && subject !== null && getSpecialStats(__spreadValues({
      seasonId: currentSeason.id,
      subject,
      filters,
      family: (_a2 = subjects.find((s) => s.value === subject)) == null ? void 0 : _a2.family
    }, sort));
    return () => {
      getSpecialStatsApi.cancel();
    };
  }, [currentSeason, subject, filters, sort]);
  useEffect(() => {
    getSpecialStatsMetaData();
    return () => {
      getSpecialStatsMetaDataApi.cancel();
    };
  }, []);
  const getSpecialStatsMetaData = async () => {
    var _a2;
    try {
      const response = await getSpecialStatsMetaDataApi.call();
      const options = mapSubjectsToOptions(response.data);
      setSubjects(options);
      setSubject((_a2 = options[0]) == null ? void 0 : _a2.value);
    } catch (error) {
      console.error("Error fetching stats metadata:", error);
    }
  };
  const getSpecialStats = async ({
    seasonId: seasonId2,
    subject: subject2,
    family,
    filters: filters2,
    sortBy,
    sortDir
  }) => {
    setLoadingTableData(true);
    try {
      const response = await getSpecialStatsApi.call({
        seasonId: seasonId2,
        subject: subject2,
        family,
        filters: filters2,
        sortBy,
        sortDir
      });
      setStatsData(response.data);
    } catch (error) {
      console.error("Error fetching stats:", error);
    } finally {
      setLoadingTableData(false);
    }
  };
  const getLeagueDetails = async ({ id: id2, seasonId: seasonId2 }, callback) => {
    setLoadingLeagueDetails(true);
    try {
      const response = await getLeagueDetailsApi.call({
        id: id2,
        seasonId: seasonId2
      });
      setLeagueDetails(response.data);
      callback == null ? void 0 : callback(
        seasonId2 ? response.data.seasons.find((s) => s.id === seasonId2) : response.data.latestSeason
      );
    } catch (error) {
      console.error("Error fetching league details:", error);
    } finally {
      setLoadingLeagueDetails(false);
    }
  };
  const handleCurrentSeasonChange = useCallback(
    (currentSeason2) => {
      const next = new URLSearchParams(searchParams);
      next.set("s", currentSeason2.id);
      setSearchParams(next);
    },
    [id, searchParams]
  );
  const handleSearchedLeague = (league) => {
    setSearchedLeague(league);
    setChosenLeague(null);
  };
  const handleChosenLeague = (league) => {
    setChosenLeague(league);
    setSearchedLeague(null);
  };
  const onSubjectChange = (e) => {
    setSubject(e.target.value);
    setFilters({});
    setSort({});
  };
  const onSortChange = ({ sortBy, sortOrder }) => {
    setSort(sortBy ? { sortBy, sortDir: toSortDir(sortOrder) } : {});
  };
  const onFilterChange = (key, value) => {
    setFilters((prev) => __spreadProps(__spreadValues({}, prev), { [key]: value }));
  };
  const onSeasonChange = (seasonId2) => {
    var _a2;
    if (seasonId2 === void 0) {
      const next = new URLSearchParams(searchParams);
      next.delete("s");
      setSearchParams(next);
      return;
    }
    const found = (_a2 = leagueDetails == null ? void 0 : leagueDetails.seasons) == null ? void 0 : _a2.find((s) => s.id === seasonId2);
    if (found)
      handleCurrentSeasonChange(found);
  };
  const onTeamRowClick = (record) => {
    const params = new URLSearchParams({ s: currentSeason.id, m: subject });
    filterOptions.forEach(
      (filter) => {
        var _a2;
        return params.set(filter.key, (_a2 = filters[filter.key]) != null ? _a2 : filter.selectedKey);
      }
    );
    const subjectItem = subjects.find((s) => s.value === subject);
    navigate(`/stats/team/${record.teamId}?${params}`, {
      state: {
        team: { name: record.teamName, icon: record.teamIcon },
        subjectLabel: subjectItem == null ? void 0 : subjectItem.label,
        filterOptions
      }
    });
  };
  const iconSize = isMobile ? 18 : 22;
  if (renderNewVersion || isMobile) {
    return /* @__PURE__ */ jsxs("div", { className: "special-stats", children: [
      (loadingLeagueDetails || loadingTableData) && /* @__PURE__ */ jsx(Loader, { overlay: true }),
      /* @__PURE__ */ jsxs(
        Flex,
        {
          vertical: true,
          gap: isMobile ? 12 : 16,
          style: {
            marginBottom: isMobile ? 16 : 20,
            paddingTop: screens.lg ? 16 : 0
          },
          children: [
            /* @__PURE__ */ jsxs("div", { className: "special-stats-grid", children: [
              /* @__PURE__ */ jsx(
                SearchLeagues,
                {
                  searchedLeague,
                  chosenLeague,
                  renderNewVersion,
                  handleSearchedLeague,
                  handleChosenLeague
                }
              ),
              /* @__PURE__ */ jsx(
                Select,
                {
                  value: currentSeason == null ? void 0 : currentSeason.id,
                  onChange: onSeasonChange,
                  options: ((_a = leagueDetails == null ? void 0 : leagueDetails.seasons) == null ? void 0 : _a.map((s) => ({
                    label: s.name,
                    value: s.id
                  }))) || [],
                  className: `stats-select ${seasonId ? "stats-select-clearable" : ""}`,
                  popupMatchSelectWidth: false,
                  disabled: !((_b = leagueDetails == null ? void 0 : leagueDetails.seasons) == null ? void 0 : _b.length),
                  allowClear: seasonId ? {
                    clearIcon: /* @__PURE__ */ jsx(
                      CloseOutlined,
                      {
                        style: {
                          color: token.colorTextBase
                        }
                      }
                    )
                  } : false,
                  suffixIcon: seasonId ? null : /* @__PURE__ */ jsx(
                    ArrowDown,
                    {
                      className: "stroke-base",
                      style: { width: 20, height: 20 }
                    }
                  ),
                  prefix: /* @__PURE__ */ jsx(
                    Calendar,
                    {
                      style: {
                        width: iconSize,
                        height: iconSize
                      },
                      className: "stroke-base"
                    }
                  )
                }
              )
            ] }),
            /* @__PURE__ */ jsxs("div", { className: "special-stats-grid special-stats-grid-filters", children: [
              /* @__PURE__ */ jsx(
                Select,
                {
                  value: subject,
                  onChange: (value) => {
                    setSubject(value);
                    setFilters({});
                    setSort({});
                  },
                  options: subjects.map((item) => ({
                    label: translateOr(
                      t,
                      `stats_subject_${item.value}`,
                      item.label
                    ),
                    value: item.value
                  })),
                  className: "stats-select stats-subject-select",
                  suffixIcon: /* @__PURE__ */ jsx(
                    ArrowDown,
                    {
                      className: "stroke-base",
                      style: { width: 20, height: 20 }
                    }
                  )
                }
              ),
              /* @__PURE__ */ jsx(
                StatsFilter,
                {
                  token,
                  renderNewVersion,
                  filterOptions,
                  filters,
                  onFilterChange
                }
              )
            ] }),
            /* @__PURE__ */ jsx(
              StatsRangeFilter,
              {
                filterOptions,
                filters,
                onFilterChange
              }
            ),
            tableData && /* @__PURE__ */ jsx(
              StatsTable,
              {
                tableData,
                renderNewVersion,
                onSortChange,
                onRowClick: onTeamRowClick
              }
            )
          ]
        }
      )
    ] });
  }
  return /* @__PURE__ */ jsxs("div", { className: "special-stats", children: [
    (loadingLeagueDetails || loadingTableData) && /* @__PURE__ */ jsx(Loader, { overlay: true }),
    /* @__PURE__ */ jsxs(
      Flex,
      {
        vertical: true,
        gap: screens.lg ? 16 : 8,
        style: {
          marginBottom: screens.lg ? 20 : 16,
          paddingTop: screens.lg ? 16 : 0
        },
        children: [
          /* @__PURE__ */ jsxs(Flex, { gap: screens.lg ? 16 : 8, wrap: "wrap", children: [
            /* @__PURE__ */ jsx(
              SearchLeagues,
              {
                searchedLeague,
                chosenLeague,
                renderNewVersion,
                handleSearchedLeague,
                handleChosenLeague
              }
            ),
            /* @__PURE__ */ jsx(
              LeagueHeader,
              {
                iconUrl: leagueDetails == null ? void 0 : leagueDetails.iconUrl,
                name: leagueDetails == null ? void 0 : leagueDetails.name,
                seasons: leagueDetails == null ? void 0 : leagueDetails.seasons,
                currentSeason,
                setCurrentSeason: handleCurrentSeasonChange,
                itemId: leagueDetails == null ? void 0 : leagueDetails.id,
                showFavoritesComponent: false,
                styles: {
                  select: {
                    height: 48,
                    width: screens.lg ? "max-content" : "100%",
                    minWidth: 164,
                    fontSize: token.fontSize
                  }
                }
              }
            ),
            /* @__PURE__ */ jsx(Title, { level: 5, style: { margin: 0 }, children: t("statistics_category") }),
            /* @__PURE__ */ jsx(
              Radio.Group,
              {
                buttonStyle: "solid",
                value: subject,
                onChange: onSubjectChange,
                className: "radio-group-default flex-wrap",
                children: subjects.map((item) => /* @__PURE__ */ jsx(Radio.Button, { value: item.value, children: /* @__PURE__ */ jsx(Space, { size: 12, children: item.label }) }, item.value))
              }
            )
          ] }),
          tableData && /* @__PURE__ */ jsx(
            StatsTable,
            {
              tableData,
              renderNewVersion,
              onSortChange,
              onRowClick: onTeamRowClick,
              children: /* @__PURE__ */ jsx(
                StatsFilter,
                {
                  token,
                  renderNewVersion,
                  keyProperty: Math.random(),
                  filterOptions,
                  onFilterChange
                }
              )
            }
          )
        ]
      }
    )
  ] });
};
var stdin_default = withScrollToTop(Stats);
export {
  stdin_default as default
};
